// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import VirginIslandsUs from '../_raw/flag/icon_flag_virgin_islands_us.png';

export default () => <img src={VirginIslandsUs} alt="VirginIslandsUs" />;
